import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Navigation } from '@/components/Navigation';
import { Footer } from '@/components/Footer';
import CanonicalTag from '@/components/CanonicalTag';
import newADURulesImage from '@/assets/new-adu-rules.jpg';

const WhatAreTheNewRulesForADUCalifornia = () => {
  const [showCalendly, setShowCalendly] = useState(false);
  const openCalendlyModal = () => setShowCalendly(true);
  const closeCalendlyModal = () => setShowCalendly(false);

  return (
    <>
      <CanonicalTag url="https://www.udaadu.com/new-adu-rules-california" />
      
      {/* Calendly Modal */}
      {showCalendly && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="relative bg-white rounded-lg w-full max-w-4xl h-full max-h-[90vh]">
            <button 
              onClick={closeCalendlyModal} 
              className="absolute top-4 right-4 z-10 p-2 bg-white rounded-full shadow-md hover:bg-gray-100 transition-colors"
            >
              ✕
            </button>
            <iframe 
              src="https://calendly.com/udaadu?embed=true&hide_gdpr_banner=1" 
              width="100%" 
              height="100%" 
              frameBorder="0" 
              title="Schedule a meeting"
            />
          </div>
        </div>
      )}
      
      <div className="min-h-screen bg-background">
        <Navigation />
        
        <main className="container mx-auto px-4 py-8">
          {/* Hero Section */}
          <div className="mb-12">
            <img 
              src={newADURulesImage} 
              alt="California ADU legislation" 
              className="w-full h-64 md:h-96 object-cover rounded-lg mb-8"
            />
            
            <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: '#E4683B' }}>
              What Are the New Rules for ADU in California?
            </h1>
            
            <p className="text-lg md:text-xl text-white leading-relaxed mb-8">
              Stay informed about the latest California ADU rules and regulations including recent legislative updates impacting your ADU project.
            </p>
          </div>

          {/* Content Sections */}
          <div className="space-y-12">
            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Recent California ADU Legislation (AB 1033, SB 897, SB 9)
              </h2>
              <p className="text-white leading-relaxed mb-6">
                AB 1033 allows ADU condominium conversions for separate sale, SB 897 streamlines permitting processes and reduces fees, while SB 9 enables lot splitting for additional housing development. These laws collectively make ADU development more accessible and financially viable for California homeowners.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                How New ADU Laws Impact Homeowners
              </h2>
              <p className="text-white leading-relaxed mb-6">
                Recent legislation reduces bureaucratic barriers, speeds up approval timelines, and provides new revenue opportunities through separate ADU sales. Homeowners benefit from standardized permitting processes, reduced impact fees, and increased flexibility in ADU design and placement on their properties.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                California City-level ADU Regulation Updates
              </h2>
              <p className="text-white leading-relaxed mb-6">
                Local jurisdictions must now comply with state ADU laws while maintaining limited local control over design standards and permitting processes. Cities can no longer impose overly restrictive requirements that effectively prohibit ADU development, ensuring more consistent and homeowner-friendly regulations statewide.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Frequently Asked Questions
              </h2>
              <div className="text-white leading-relaxed space-y-6">
                <div>
                  <p className="font-semibold mb-2">Q: What's new in California ADU laws this year?</p>
                  <p>A: Increased flexibility, permitting speed-ups, and allowance for separate ADU sales under AB 1033.</p>
                </div>
                
                <div>
                  <p className="font-semibold mb-2">Q: How do California's new ADU rules benefit homeowners?</p>
                  <p>A: Easier permitting, fewer restrictions, and new income opportunities from ADUs.</p>
                </div>
              </div>
            </section>
          </div>

          {/* Call-to-Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-12">
            <Button 
              onClick={openCalendlyModal}
              className="bg-primary text-primary-foreground hover:bg-primary/90 px-8 py-3 text-lg"
            >
              Book & Schedule
            </Button>
            <Button 
              asChild
              variant="outline"
              className="border-primary text-primary hover:bg-primary hover:text-primary-foreground px-8 py-3 text-lg"
            >
              <Link to="/landing">Learn More</Link>
            </Button>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default WhatAreTheNewRulesForADUCalifornia;